import { notify } from "shared/src/utils/Notifications";

import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import StoreAction from "../../../../actions/StoreAction";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import CustomerStore from "../../../../stores/CustomerStore";
import { StoreSelectionDropdown } from "./StoreSelectionDropdown";
import { DropDownOption } from "./StoreSelectionDropdown";
import { StoreType } from "../../../../datatypes/Store";
import { FsdAddressType } from "shared/src/types/customer/FsdAddress";
import { isEmpty, isNil } from "shared/src/utils/util";

type Props = {
    store: StoreType | undefined | null;
    stores: Array<StoreType>;
    deliveryAddresses: Array<FsdAddressType>;
    onStoreSelect: () => void;
    hideTitle: boolean;
    renderInPopover: boolean;
    inMobileMenu: boolean;
    onlineVisibleStore: Array<string>;
};

class StoreSelector extends React.Component<
    Props,
    {
        newSelectedStore?: DropDownOption;
    }
> {
    constructor(props: Props) {
        super(props);
        const selectedAddressHash: string | undefined | null = SessionStore.getSelectedDeliveryAddressHash();
        const store = props.store;
        if (store) {
            this.state = {
                newSelectedStore: {
                    value: {
                        type: selectedAddressHash ? "address" : "store",
                        store: store,
                        address: selectedAddressHash
                            ? props.deliveryAddresses.find((address) => address.hash === selectedAddressHash)
                            : undefined
                    },
                    label: store.storeDisplayName
                }
            };
        }
    }

    saveSelectedStore(selection: DropDownOption) {
        this.setState({
            newSelectedStore: selection
        });
    }

    onSubmit = () => {
        const locationNumber = this.state?.newSelectedStore?.value?.store?.storeId?.locationNumber ?? undefined;
        if (this.state.newSelectedStore && !isNil(locationNumber)) {
            const value = this.state.newSelectedStore.value;
            if (value.type === "address") {
                SessionStore.setDeliveryAddress(value.address);
            } else {
                StoreAction.storeSelected(value.store);
                SessionStore.setDeliveryAddress(null); // selecting a store means deselecting any FSD delivery address
                SessionStore.setSelectedStoreId(locationNumber);
                const customer = CustomerStore.getCustomer();
                if (customer && customer.validForFsd) {
                    const notification = {
                        type: "success" as const,
                        key: "EX_STORE_SELECT_FSD_CUSTOMER_NON_FSD_STORE",
                        values: [],
                        id: "EX_STORE_SELECT_FSD_CUSTOMER_NON_FSD_STORE"
                    };
                    notify(notification);
                }
            }
        }
        this.props.onStoreSelect();
    };

    renderStoreSelectionHeadline() {
        const message = this.props.store ? "EX_GLOBAL_HEADER_SELECT_OTHER_STORE" : "EX_GLOBAL_HEADER_SELECT_STORE";
        return (
            <h3 className={"ex-address-search-header"}>
                <FormattedMessage id={message} />
            </h3>
        );
    }

    renderStoreSelectionButton() {
        return (
            <Button className="ex-store-selector-submit-button" onClick={this.onSubmit} bsStyle="primary" block>
                <FormattedMessage id="EX_GLOBAL_HEADER_SELECT_STORE" />
            </Button>
        );
    }

    getListOfSelectableStores(): Array<StoreType> {
        return isEmpty(this.props.onlineVisibleStore)
            ? (this.props.stores ?? []).filter(
                  (s) => s && s.storeId && s.storeId.locationNumber === SessionStore.getDefaultStoreForAnon()
              )
            : (this.props.stores ?? []).filter(
                  (s) => s && s.storeId && (this.props.onlineVisibleStore ?? []).includes(s.storeId.locationNumber)
              );
    }

    selectStoreForMobile(selection: DropDownOption) {
        this.setState(
            {
                newSelectedStore: selection
            },
            this.onSubmit
        );
    }

    render() {
        const largeScreenProportion = this.props.renderInPopover ? 4 : 3;
        const selectableStores = this.getListOfSelectableStores();
        if (isEmpty(selectableStores) && !this.props.inMobileMenu) {
            return (
                <Row className="popover-well">
                    <Col xs={12} sm={4} lg={largeScreenProportion}>
                        <h3 className={"ex-address-search-header"}>
                            <FormattedMessage id="EX_STORE_SELECTION_NO_OTHER_STORE_SELECTABLE" />
                        </h3>
                    </Col>
                </Row>
            );
        }
        const selectedOption = !isEmpty(this.state) ? this.state.newSelectedStore : null;
        return (
            <Row className="popover-well">
                {!this.props.inMobileMenu ? (
                    <Col xs={12} sm={4} lg={largeScreenProportion}>
                        {this.renderStoreSelectionHeadline()}
                    </Col>
                ) : null}
                <Col xs={12} sm={4} lg={largeScreenProportion}>
                    <StoreSelectionDropdown
                        stores={selectableStores}
                        deliveryAddresses={this.props.deliveryAddresses}
                        onChange={
                            this.props.inMobileMenu
                                ? this.selectStoreForMobile.bind(this)
                                : this.saveSelectedStore.bind(this)
                        }
                        selectedOption={selectedOption}
                        inMobileMenu={this.props.inMobileMenu}
                    />
                </Col>
                <Col xs={12} sm={4} lg={largeScreenProportion}>
                    {!this.props.inMobileMenu && this.renderStoreSelectionButton()}
                </Col>
            </Row>
        );
    }
}
export default StoreSelector;
